import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
import { Button } from 'react-bootstrap';

const Globals = require('../../../../app/globals');
const SignInActions = require('../../actions/sign_in_actions');
const AdminGlobalUserStore = require('../../stores/AdminGlobalUserStore');
import ErrorBox from '../common/ErrorBox';
import SuccessBox from '../common/SuccessBox';

const propTypes = {
    user: PropTypes.object.isRequired
};

const defaultProps = {};

class AdminEmulateThirdPartyUser extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            password: '',
            actionId: null,
            clearActionId: null,
            error: null,
            emulated3pUserInfo: AdminGlobalUserStore.getState().emulated3pUserInfo
        };

        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.emulate = this.emulate.bind(this);
        this.clearEmulation = this.clearEmulation.bind(this);
        this.unsubscribes = [
            AdminGlobalUserStore.listen(this.onAdminGlobalUserStoreChange.bind(this))
        ];
    }

    componentDidUpdate() {
        this.unsubscribes.forEach(u => u());
    }

    onAdminGlobalUserStoreChange(state) {
        if (state.action.id === this.state.actionId) {
            this.setState({ error: state.action.error, emulated3pUserInfo: state.emulated3pUserInfo, actionId: null, password: '' });
        }
        else if (state.action.id === this.state.clearActionId) {
            this.setState({ error: null, emulated3pUserInfo: state.emulated3pUserInfo, clearActionId: null });
        }
    }

    onPasswordChange(e) {
        this.setState({ password: e.target.value });
    }

    emulate() {
        if (this.state.actionId) {
            return;
        }

        const actionId = uuid.v4();
        this.setState({ error: null, actionId: actionId }, () => {
            SignInActions.emulate3p(actionId, { userId: this.props.user.id, password: this.state.password });
        });
    }

    clearEmulation() {
        const clearActionId = uuid.v4();
        this.setState({ error: null, clearActionId: clearActionId }, () => {
            SignInActions.clearEmulate3p(clearActionId);
        });
    }

    render() {
        if (this.props.user.type !== Globals.users.type.EXTERNAL) {
            return (
                <div>
                    Unavailable for this user type.
                </div>
            );
        }

        const userIsEmulated = this.state.emulated3pUserInfo.id === this.props.user.id;
        return (
            <div>
                {(userIsEmulated) &&
                    <SuccessBox>You are emulating this user!</SuccessBox>
                }
                <input type='password' value={this.state.password} onChange={this.onPasswordChange} />
                <Button
                    className="margin-left-md"
                    disabled={!this.state.password.length || this.state.actionId}
                    onClick={this.emulate}>
                        Sign in
                </Button>
                {(userIsEmulated) &&
                    <Button
                    className="margin-left-md"
                    disabled={!!this.state.clearActionId}
                    onClick={this.clearEmulation}>
                        Sign out
                    </Button>
                }
                <ErrorBox error={this.state.error} />
            </div>
        );
    }
}

AdminEmulateThirdPartyUser.propTypes = propTypes;
AdminEmulateThirdPartyUser.defaultProps = defaultProps;

export default AdminEmulateThirdPartyUser;